// NPM Modules
import React from 'react';

// Modules
import '../styles/recipedia.css';

class AlmostThere extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="main">
        <div id="top" className="landing-main">
          <div className="container text-vertical-center">
            <center><img src="https://s3.eu-west-2.amazonaws.com/recipedia/recipedia-logo.jpeg" className="recipedia-logo img-responsive" alt="Recipedia Logo"></img></center>
            <div className="row">
              <div className="col-xs-8 col-xs-offset-2">
                <h2 className="white">You’re nearly ready to go...</h2>
                <h4 className="white">Before using Recipedia, please click on the link in the verification email to verify your account and get started.</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

};

export default AlmostThere;



// WEBPACK FOOTER //
// ./src/components/AlmostThere.js